import { jsxs as h, jsx as t, Fragment as D } from "@emotion/react/jsx-runtime";
import { useTheme as E } from "@emotion/react";
import { StyledSvgContainer as g, StyledValueWithoutChild as u, StyledValue as T, StyledLabel as C } from "./RadialBar.styled.js";
import { Stack as L } from "../Stack/index.js";
import { StrokeType as W } from "../../types/components/radialBar.js";
const x = ({
  value: o = 0,
  activeColor: p = "emerald",
  inactiveColor: f = "secondary",
  strokeType: I = W.NORMAL,
  valueColor: S,
  labelColor: $,
  children: a
}) => {
  const c = E(), r = 90, s = 20, l = 200, d = 100, n = Math.PI * r, e = o / 100 * n, i = `M 10,100 A ${r},${r} 0 1,1 ${10 + 2 * r},100`, k = (m, y = "initial") => c.colors[m]?.[y] || m;
  return /* @__PURE__ */ h(L, { direction: "column", alignItems: "center", justifyContent: "center", children: [
    /* @__PURE__ */ t(g, { children: /* @__PURE__ */ h("svg", { width: l, height: d, viewBox: `0 0 ${l} ${d}`, children: [
      /* @__PURE__ */ t("path", { d: i, strokeWidth: s, fill: "transparent", stroke: k(p), strokeDasharray: `${e} ${n - e}`, strokeDashoffset: 0, strokeLinecap: "butt" }),
      /* @__PURE__ */ t("path", { d: i, strokeWidth: s, stroke: k(f, "alpha"), fill: "transparent", strokeDasharray: `${n - e} ${e}`, strokeDashoffset: -e, strokeLinecap: "butt" }),
      /* @__PURE__ */ t("path", { d: i, strokeWidth: s + 5, fill: "transparent", strokeDasharray: I, strokeLinecap: "butt", stroke: c.colors.theme.background })
    ] }) }),
    !a && /* @__PURE__ */ t(u, { as: "h1", variant: "heading1", children: `${o}%` }),
    a && /* @__PURE__ */ h(D, { children: [
      /* @__PURE__ */ t(T, { as: "h1", variant: "heading1", color: S, children: `${o}%` }),
      /* @__PURE__ */ t(C, { as: "div", color: $, children: a })
    ] })
  ] });
};
export {
  x as RadialBar
};
